import * as XLSX from 'xlsx';
import { frenchMonth } from '../../../../variables/functions';

// Libellé « Mois AAAA » à partir d'une période « AAAA-MM ».
export const moisPeriodeLabel = (periode) =>
    periode ? `${frenchMonth(periode.split('-')[1])} ${periode.split('-')[0]}` : '';

// Nom de fichier sûr (accents/espaces → _).
const fileSafe = (s) => `${s || ''}`.normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z0-9-]+/g, '_').replace(/^_+|_+$/g, '');

/**
 * Export Excel générique d'un bordereau de cession. Reproduit l'en-tête du PDF
 * (titre + période + catégorie + compagnie) puis le tableau ; les montants sont
 * exportés en NOMBRES (Excel peut les sommer), pas en chaînes formatées.
 *
 * @param {Object}   o
 * @param {string}   o.titre        Titre du bordereau (majuscules).
 * @param {string[]} o.metaLines    Lignes d'info sous le titre (période, compagnie…).
 * @param {string[]} o.headers      En-têtes de colonnes.
 * @param {Array[]}  o.rows         Lignes (tableau de tableaux) — nombres pour les montants.
 * @param {Array}    [o.totalRow]   Ligne TOTAL (facultative).
 * @param {string}   o.nomFichier   Nom du fichier (sans extension).
 */
export const exportBordereauExcel = ({ titre, metaLines = [], headers, rows, totalRow, nomFichier }) => {
    const aoa = [[titre], ...metaLines.map((l) => [l]), [], headers, ...rows];
    if (totalRow) aoa.push(totalRow);
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Bordereau');
    XLSX.writeFile(wb, `${fileSafe(nomFichier)}.xlsx`);
};
